import { inject, Injectable } from '@angular/core';
import { DownloadService, INavigationActionHandler } from '@polygon/components';

@Injectable()
export class CustomDownloadHandler implements INavigationActionHandler {
	private downloadService = inject(DownloadService);

	async action(event: Event): Promise<boolean> {
		const anchor = event.currentTarget as HTMLAnchorElement;

		// Handle specific async routes
		if (anchor.pathname.includes('/corePatterns/downloadFiles/')) {
			event.preventDefault();

			await this.downloadService.download(anchor.href, 'blob');

			return true; // Prevent default navigation
		}

		return false; // Let other handlers or default navigation proceed
	}
}
